function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genTreeViewStyles = function genTreeViewStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".headerItem", _defineProperty(_defineProperty({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 8px',
    margin: '0 24px',
    borderBottom: '1px solid #EEEEF3',
    cursor: 'pointer'
  }, ".title", {
    fontSize: '16px',
    color: '#0D1121'
  }), ".fileInput", {
    display: 'none' // 确保隐藏但不影响功能
  })), ".headerItem:hover", {
    backgroundColor: '#F4F4F4'
  }), ".selectedType", {
    borderBottom: "1px solid transparent"
  }), ".treeWrap", {
    padding: '0 24px'
  }), '.ant-tree .ant-tree-switcher', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }))];
};